export const REDUCER_NAME = "metaDataSlice";

// DTO for sending data (request payload)
export interface iMetaDataDTO {
    meta_name: string;
    meta_content: string;
}

// Response structure for single meta tag
export interface iMetaTag {
    id: string;
    meta_name: string;
    meta_content: string;
}

// Response structure from API
export interface iMetaDataResponse {
    metaTags: iMetaTag[];
}

export interface iMetaDataState {
    metaDataList: iMetaTag[];
    isLoading: boolean;
    errorMessage: string | null;
}